import { render, staticRenderFns } from "./ItemCounter.vue?vue&type=template&id=2e51a70b&scoped=true&"
import script from "./ItemCounter.vue?vue&type=script&lang=js&"
export * from "./ItemCounter.vue?vue&type=script&lang=js&"
import style0 from "./ItemCounter.vue?vue&type=style&index=0&id=2e51a70b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51a70b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ItemCounter.vue
// module id = null
// module chunks = 